export default __webpack_public_path__ + "static/media/blog-4.a769e38b.jpg";